import { dictionary } from './dictionary';
import { DictionaryField } from './fields';

export const useDictionary = () => ({
  DictionaryField,
  dictionary,
});
